export default "__VITE_ASSET__CzQMRyBw__"